<template>
  <div id="layout">
    <ToLoginDialog ref="toLoginDialog"></ToLoginDialog>
    <Header></Header>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="layout-right"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="layout-right"></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import ToLoginDialog from '@/components/ToLoginDialog'

export default {
  name: 'layout',
  components: {
    Header,
    Footer,
    ToLoginDialog
  }
}
</script>

<style lang="scss">
#layout {
  min-width: 1200px;
  // min-height: 100vh;
  padding: 80px 0 0 0;
  position: relative;
}
</style>
